import { render } from "./B2bTableMenuOrdersEmit.vue?vue&type=template&id=7e03f0cd&scoped=true&lang=pug"
import script from "./B2bTableMenuOrdersEmit.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuOrdersEmit.vue?vue&type=script&lang=js"

import "./B2bTableMenuOrdersEmit.vue?vue&type=style&index=0&id=7e03f0cd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e03f0cd"]])

export default __exports__